import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

const DynamicForm = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [generatedFields, setGeneratedFields] = useState([]);

  const fields = [
    { id: 'accountName', label: 'Account Name' },
    { id: 'accountNumber', label: 'Account Number' },
    { id: 'email', label: 'Email' },
    { id: 'phoneNumber', label: 'Phone Number' },
    { id: 'address', label: 'Address' },
    { id: 'city', label: 'City' },
    { id: 'state', label: 'State' },
    { id: 'zipCode', label: 'Zip Code' },
    { id: 'country', label: 'Country' },
    { id: 'accountType', label: 'Account Type' },
  ];

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const handleCheckboxChange = (event, fieldId) => {
    const isChecked = event.checked;
    if (isChecked) {
      setSelectedFields((prev) => [...prev, fieldId]);
    } else {
      setSelectedFields((prev) => prev.filter((id) => id !== fieldId));
    }
  };

  const handleSubmit = () => {
    setGeneratedFields(fields.filter((field) => selectedFields.includes(field.id)));
    setDrawerOpen(false);
  };

  return (
    <div>
    <Button label="Create Form" icon="pi pi-plus" onClick={() => toggleDrawer(true)} />
    <Sidebar visible={drawerOpen} position="right" onHide={() => toggleDrawer(false)}>
      <h3>Select Fields</h3>
      {fields.map((field) => (
        <div key={field.id} className="p-field-checkbox my-2">
          <Checkbox className=''
            inputId={field.id}
            checked={selectedFields.includes(field.id)}
            onChange={(e) => handleCheckboxChange(e, field.id)}
          />
          <label className='ps-2' htmlFor={field.id}>{field.label}</label>
        </div>
      ))}
      <Button label="Generate Form" icon="pi pi-check" onClick={handleSubmit} />
    </Sidebar>

    {generatedFields.length > 0 && (
      <div style={{ marginTop: '20px' }}>
        <h3>Generated Form</h3>
        <form>
          {generatedFields.map((field) => (
            <div key={field.id} className="p-field" style={{ marginBottom: '10px' }}>
              <label htmlFor={field.id}>{field.label}</label>
              <InputText id={field.id} placeholder={field.label} />
            </div>
          ))}
          <Button type="submit" label="Submit" icon="pi pi-check" />
        </form>
      </div>
    )}
  </div>
  )
}

export default DynamicForm